import { render, staticRenderFns } from "./PrivacyPageEn.vue?vue&type=template&id=68b19232&scoped=true"
import script from "./PrivacyPageEn.vue?vue&type=script&lang=js"
export * from "./PrivacyPageEn.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPageEn.vue?vue&type=style&index=0&id=68b19232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b19232",
  null
  
)

export default component.exports